<template>
  <form @submit="register">
    <div class="pt-1">
      <div
        class="form-group"
      >
        <label>{{ $t('lang.forms.name') }}</label>
        <input
          id="name"
          v-model="user.full_name"
          class="form-control"
          type="text"
          name="name"
          required
        >
        <i class="ti-user" />
      </div>

      <UserCountry @countrySelected="updateUserCountry" />

      <div class="form-group">
        <label>{{ $t('lang.forms.email') }}</label>
        <input
          id="email"
          v-model="user.email"
          class="form-control"
          type="email"
          name="email"
          required
        >
        <i class="icon_mail_alt" />
      </div>

      <div class="form-group">
        <label>{{ $t('lang.forms.password') }}</label>
        <input
          id="password"
          v-model="user.password"
          class="form-control password-input"
          :type="showPassword ? 'text' : 'password'"
          name="password"
          required
        >

        <i class="icon_lock_alt" />
        <button
          type="button"
          class="password-toggle"
          :aria-label="passwordVisibilityLabel(showPassword)"
          :aria-pressed="showPassword"
          @click="showPassword = !showPassword"
        >
          <span :class="showPassword ? 'icon-eye-off' : 'icon-eye'" />
        </button>
      </div>

      <div class="form-group mt-3">
        <label class="container_check">
          {{ $t('lang.forms.terms_and_conditions_text') }}
          <a
            target="_blank"
            href="/terms-and-conditions#tyc"
          >{{ $t('lang.forms.terms_and_conditions_link') }}</a>
          {{ $t('lang.forms.privacy_policy_text') }}
          <a
            target="_blank"
            href="/terms-and-conditions#privacy"
          >{{ $t('lang.forms.privacy_policy_link') }}</a>
          <input
            id="terms_and_conditions"
            type="checkbox"
            name="terms_and_conditions"
            checked
            required
          >
          <span class="checkmark" />
        </label>
      </div>

      <Errors :errors="errors" />

      <div
        v-if="success"
        class="alert alert-success"
      >
        {{ $t('lang.alerts.register_success') }}
      </div>

      <button
        type="submit"
        class="btn_1 btn_secondary full-width mt-4"
        :disabled="validated"
      >
        <span v-if="validated"><i
          class="icon-spin6 animate-spin"
          style="font-size: 130%"
        /></span>
        <span v-else>{{ $t('lang.user.button') }}</span>
      </button>
      <div class="float-right mt-1 mb-3">
        <span
          v-if="user.referral_code"
          class="link-light nopadding text-right"
        >{{ $t('lang.user.referral_code') +': '+ user.referral_code }}
          <button
            class="btn btn-link link-light nopadding text-right"
            style="font-size: 14px;"
            @click="askForReferralCode()"
          >
            <i class="icon-pencil-neg color-secondary" />
          </button>
        </span>
        <button
          v-else
          class="btn btn-link link-light nopadding text-right"
          style="font-size: 14px;"
          @click="askForReferralCode()"
        >
          {{ $t('lang.user.referral_button') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import UserCountry from '@/components/User/UserCountry';
import Errors from '../Alerts/Errors';

import { API, errorResponse } from '../../api/api';

const AuthAPI = API.get('auth');

// @vuese
// Vista formulario para realizar el registro de un usuario.
export default {
  name: 'RegisterForm',

  components: {
    UserCountry,
    Errors,
  },

  data() {
    return {
      user: {
        full_name: '',
        country: '',
        email: '',
        password: '',
        referral_code: this.$store.state.main.referral_code,
        uuid: this.$store.state.main.uuid,
      },
      errors: {},
      success: false,
      validated: false,
      showPassword: false,

    };
  },
  computed: {

    fullNameIsValid() { // Simple validation, real validation is on insurance data or user account
      const r = /(\S\S+\s+\S\S)+/i;

      if (r.test(this.user.full_name)) {
        return true;
      }
      return false;
    },
  },

  methods: {
    passwordVisibilityLabel(isVisible) {
      return this.$t(isVisible ? 'lang.forms.hide_password' : 'lang.forms.show_password');
    },

    updateUserCountry(country) {
      this.user.country = country;
    },

    // @vuese
    // Submit form data to server
    async register(e) {
      e.preventDefault();

      this.errors = {};
      if (this.fullNameIsValid) {
        this.validated = true;

        try {
          const { data } = await AuthAPI.register(this.user);

          this.$emit('authenticatedUser', data, 'sign_up');
        } catch (error) {
          this.errors = errorResponse(error);
        }
        this.validated = false;
      } else {
        this.errors = { full_name_error: [this.$t('lang.forms.full_name_error')] };
      }
    },

    askForReferralCode() {
      const referralCode = prompt(this.$t('lang.user.enter_referral_code'));
      if (referralCode !== '' && referralCode !== null) {
        this.user.referral_code = referralCode;
        this.$store.dispatch('setReferral', referralCode);
      }
    },
  },
};

</script>
